import { noop } from "common/functions";
import { delay } from "common/promises";
import { TransitionImage } from "common/ui/transitionImage";
import { onVideoTime } from "common/video";
import log from "loglevel";
import { load } from "seventh-animation/loader";
import { Scene } from "seventh-animation/scene/main";
import { toPath } from "seventh-animation/scene/resources";
import { Param } from "../common";
export async function start({ context, input, }) {
    const sound = await load({ progressCallback: noop });
    const transitionImage = new TransitionImage({
        parent: document.querySelector("#all-container"),
        imageURL: toPath("transition-image.jpg"),
    });
    const { videoElem, progressElem } = await input.waiter.wait();
    transitionImage.show();
    $(videoElem).hide();
    context.interactionVideoLoader.clearMovie("2번 영상.mp4");
    context.interactionVideoLoader.runWhenLoaded("3번 영상.mp4", async (elem) => {
        log.info("third video loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    const scene = new Scene();
    await scene.start({
        parentSelector: "#all-container",
        sound,
        transitionImage,
    });
    await context.interactionVideoLoader.wait("3번 영상.mp4");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 3, video: videoElem });
    const ret = new Param();
    onVideoTime({
        videoElement: videoElem,
        timeMillis: (videoElem.duration - 1) * 1000,
        callback: () => {
            progressElem.fadeOutAndHide();
        },
    });
    $(videoElem).one("ended", () => {
        ret.fill({ videoElem, progressElem });
    });
    return ret;
}
export async function skippedStart({ context, input, waitVideo, }) {
    const { videoElem, progressElem } = await input.waiter.wait();
    $(videoElem).hide();
    progressElem.fadeOutAndHide();
    context.interactionVideoLoader.runWhenLoaded("3번 영상.mp4", async (elem) => {
        log.info("third video loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    await context.interactionVideoLoader.wait("3번 영상.mp4");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 3, video: videoElem });
    const ret = new Param();
    if (waitVideo) {
        await delay(1000);
        videoElem.currentTime = videoElem.duration - 4;
        onVideoTime({
            videoElement: videoElem,
            timeMillis: (videoElem.duration + 1) * 1000,
            callback: () => progressElem.fadeOutAndHide(),
        });
        $(videoElem).one("ended", () => {
            ret.fill({ videoElem, progressElem });
        });
    }
    else {
        ret.fill({ videoElem, progressElem });
    }
    return ret;
}
//# sourceMappingURL=main.js.map